<template>
  <div>
    <van-nav-bar
      title="编辑基本信息"
      left-arrow
      fixed
      placeholder
      @click-left="onClickLeft">
    </van-nav-bar>
    <div class="form">
      <div class="user-img">
        <van-icon name="bianji"></van-icon>
        <img src="../../../assets/img/userd.png"/>
      </div>
      <van-cell-group class="form-cont">
        <van-field input-align="right" label="姓名" value='张三' placeholder="" />
        <van-field
          readonly
          input-align="right"
          label="性别"
          :rules="[{ message: '请选择称谓' }]">
          <template #input>
            <van-radio-group v-model="radio" direction="horizontal">
              <van-radio name="1">先生 Mr</van-radio>
              <van-radio name="2">女士 Ms</van-radio>
            </van-radio-group>
          </template>
        </van-field>

        <van-field
          input-align="right"
          readonly
          @click="selectbirth = true"
          is-link
          :value="birthday"
          label="出生年月"
          clickable
          placeholder="请选择出生年月"
          :rules="[{ message: '请选择出生年月' }]">
        </van-field>

        <van-field
          input-align="right"
          readonly
          value=""
          label="参加工作时间"
          @click="selectbirth = true"
          is-link
          placeholder="参加工作时间"
          :rules="[{ message: ' ' }]">
        </van-field>
        <van-field  input-align="right" label="手机号" value="18934567891" />
        <van-field  input-align="right" label="电子邮箱" value="nijddfjf@gmail.com" />
      </van-cell-group>
    </div>
    <div class="fixed-bottom">
      <van-button type="primary" class="btn-blue" color="linear-gradient(to right top, #2F72F6,#1C54CF)" round>保 存</van-button>
    </div>
    <!--选择生日-->
    <van-popup v-model="selectbirth" position="bottom" style="width: 100%;">
      <van-datetime-picker
        v-model="currentDate"
        type="date"
        title="选择时间"
        @cancel="selectbirth = false"
        @confirm="onConfirmBirth"
      />
    </van-popup>
  </div>
</template>

<script>
export default {
  name: 'basicInfo',
  data() {
    return {
      radio: '1',
      value: '',
      minDate: new Date(2020, 0, 1),
      maxDate: new Date(2025, 10, 1),
      currentDate: new Date(),
      birthday: '1990-10-10',
      selectbirth: false
    }
  },
  methods: {
    onClickLeft() {
      this.$router.go(-1)
    },
    formatter(type, val) {
      if (type === 'month') {
        return `${val}月`
      } else if (type === 'day') {
        return `${val}日`
      }
      return val
    },
    onConfirmBirth() {
      this.birthday = this.currentDate.getFullYear() + "-" +
        (Number(this.currentDate.getMonth()) + 1) +
        "-" +
        this.currentDate.getDate()
      this.selectbirth = false
    }
  }
}
</script>

<style lang="less" scoped>
  .user-img{
    position: relative;
    width: 88px;
    margin:20px auto 40px;
    img{
      width: 88px;
      height: 88px;
    }
    i{
      position: absolute;
      right:0;
      top:0;
      color:#2F72F6;
      font-size: 22px;
    }
  }
  /deep/.van-cell{
    padding:20px 16px;
  }
  /deep/.van-hairline--top-bottom::after,/deep/.van-hairline-unset--top-bottom::after{
    display: none;
  }
  /deep/.van-cell__right-icon{
    transform: rotate(90deg);
    top:-4px;
  }
  .fixed-bottom{
    padding:10px 16px 20px;
    button{
      flex:1;
    }
  }
</style>
